import { useMemo } from "react";

interface VanityUrlDetail {
  status: string;
  vanity_url_type: string;
  domain_name: string;
}

interface UserAuthData {
  vanityMspDetails?: VanityUrlDetail[];
}

/**
 * Pure builder for the shareable article URL (vanity domain or current host).
 * Use this when you need a URL outside of a hook (e.g. building several at once
 * in an event handler/loop).
 */
export const buildArticleShareUrl = (
  userAuthData: UserAuthData | undefined,
  articleId: string,
): string => {
  const vanityUrlData = userAuthData?.vanityMspDetails;
  if (vanityUrlData && vanityUrlData.length > 0) {
    const webDomains = vanityUrlData.filter(
      (item) =>
        item?.status === "ACTIVE" && item.vanity_url_type === "WEB_APP_URL",
    );
    if (webDomains.length > 0) {
      return `https://${webDomains[0].domain_name}/article/${articleId}`;
    }
  }

  return `https://${window.location.hostname}/article/${articleId}`;
};

/**
 * Generates the shareable article URL based on vanity domain or current hostname
 */
export const useArticleShareUrl = (
  userAuthData: UserAuthData | undefined,
  articleId: string,
): string => {
  return useMemo(
    () => buildArticleShareUrl(userAuthData, articleId),
    [userAuthData, articleId],
  );
};
